import React from 'react';

// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
// components
import { MetaHelmet } from '../../layouts/Helmet/Helmet';
import PreOwnedService from '../../segment/Inspection/InspectionService';
import InspectCarBannerMobile from '../../segment/Inspection/InspectiCarBannerMobile';
import RiskHardEarnedMoney from '../../segment/Inspection/BuyarService';
import CertifiedInspection from '../../segment/Inspection/InspectionDirectly';
import TransparentReport from '../../segment/Inspection/ScanningCode';
import InspectionComparison from '../../segment/Inspection/InspectionComparison';
import Backed12Year from '../../segment/Inspection/Bcked16Year';
import ReviewSection from '../../segment/Inspection/Testimonial';
import BookFromAnywere from '../../segment/Inspection/BookFromAnywere';
import WhatsappSection from '../../segment/Inspection/WhatsappSection';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export default function InspectionPageMobile() {
  return (
    <>
      <MetaHelmet title={'Pre-Purchase Car Inspection in Kerala'} companyName={'Focus Motors'} />

      <StyledRoot className="bg-color ">
        <Container className="landgmainsection landgmainsection-inspection" maxWidth="lg" sx={{ pb: 0 }}>
          <InspectCarBannerMobile />
          <PreOwnedService />
          <RiskHardEarnedMoney />
          <CertifiedInspection />
          <TransparentReport />
          <InspectionComparison />
          <Backed12Year />
          <ReviewSection />
          <BookFromAnywere />
          <WhatsappSection />
        </Container>
      </StyledRoot>
    </>
  );
}
